import React, { useEffect, useState } from "react";
import './kyc.scss';
import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import YourProfile from './components/YourProfile.jsx';
import OpenAccount from './components/OpenAccount.jsx';
import AccountType from './components/AccountType.jsx';
import MakeDeposit from './components/MakeDeposit.jsx';
import StartTrading from './components/StartTrading.jsx';
import DepositZaropayUSDT from "./components/DepositZaropayUSDT.jsx";
import KycRequested from "./components/KycRequested.jsx";
import KycForm from "./components/KycForm.jsx";


export default function Kyc() {

  const [searchParams] = useSearchParams();
  const { userDetails } = useSelector(state => state.user);
  const [activeTab, setActiveTab] = useState(searchParams.get('step') || 'profile');
  const [pending, setPending] = useState(false);
  const tabs = [{ id: ['profile'], order: 0, title: 'Complete Your Profile' }, { id: ['account', 'account-type'], order: 1, title: 'Open Account' }, { id: ['deposit', 'deposit-zaropay-usdt'], order: 2, title: 'Make Deposit' }, { id: ['start-trading'], order: 3, title: 'Start Trading' }];

  useEffect(() => {
    if (userDetails?.kycStatus === 'Pending') {
      setPending(true);
    }
  }, [userDetails?.kycStatus]);

  useEffect(() => {
    setActiveTab(searchParams.get('step'));
  }, [searchParams.get('step')])

  const renderBody = () => {
    switch (activeTab) {
      case 'profile':
        return <YourProfile />;
      case 'account':
        return <OpenAccount />;
      case 'account-type':
        return <AccountType />;
      case 'deposit':
        return <MakeDeposit />;
      case 'deposit-zaropay-usdt':
        return <DepositZaropayUSDT />;
      case 'start-trading':
        return <StartTrading />;
    }
  }

  return (
    <div className="">
      {pending ? <KycRequested setPending={setPending} /> : <KycForm />}
    </div>
  );
} 

